import * as React from 'react';
import './courseLessonList.module.scss';
import { BrushedLabel } from '../../../atoms/layout/BrushedLabel';

export class CourseLessonList extends React.Component {
    render() {
        const { children } = this.props;
        return (
            <div styleName="list-wrapper">
                <div styleName="list">
                    <div styleName="list-header">
                        <BrushedLabel>レッスン一覧</BrushedLabel>
                    </div>
                    <div styleName="list-body">{children}</div>
                </div>
            </div>
        );
    }
}
